import { render } from "./Carousel.vue?vue&type=template&id=475e99ce"
import script from "./Carousel.vue?vue&type=script&lang=ts"
export * from "./Carousel.vue?vue&type=script&lang=ts"
script.render = render

export default script